<template>
  <div class="columns p-3 m-0">
    <div class="column p-0 m-0">
      <!-- Heading and Buttons -->
      <div class="columns is-vcentered p-0 m-0 pb-2 bb-grey-1">

        <div class="column p-0 m-0 is-size-6 is-6">
          <slot name="heading" />
        </div>

        <div class="column p-0 m-0">
          <div class="is-flex is-flex-direction-row-reverse">
            <slot name="heading_buttons" />
          </div>
        </div>

      </div>

      <!-- Body -->
      <div class="columns p-0 m-0">
        <div class="column p-0 m-0">
          <slot name="body" />
        </div>
      </div>

      <!-- Footer -->
      <div class="columns p-0 m-0 pt-2">
        <div class="column p-0 m-0">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuotePartsControlSection'
}
</script>

<style lang="scss">
@use "@/assets/style/override-colours" as oc;
.bb-grey-1 {
  border-bottom: 1px solid oc.$grey;
}
</style>